import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  { n: "01", t: "Claim it", d: "Create an account and hit “Claim this item”. No card needed — your spot in line is saved instantly." },
  { n: "02", t: "We reach out", d: "We message you directly to confirm details, answer questions and arrange payment." },
  { n: "03", t: "Ships to you", d: "Your piece is packed with care in BC and shipped anywhere in Canada." },
];

export const HowItWorks = () => (
  <section className="relative border-y border-[#281245] bg-[#0b0514]" data-testid="how-it-works">
    <div className="mx-auto grid max-w-[1400px] gap-16 px-5 py-28 md:px-10 md:py-36 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow>How buying works</Eyebrow>
        <h2 className="font-display mt-5 text-5xl leading-[0.95] text-[#f3eefc] md:text-6xl">Personal, <br /><span className="italic text-[#d8b4fe]">not checkout.</span></h2>
      </Reveal>
      <div className="lg:col-span-8">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.1} className="group grid grid-cols-[auto_1fr] gap-8 border-t border-[#281245] py-10 last:border-b">
            <span className="font-display text-6xl italic text-[#7c3aed] transition-colors duration-500 group-hover:text-[#d8b4fe] md:text-7xl">{s.n}</span>
            <div>
              <h3 className="font-display text-3xl text-[#f3eefc]">{s.t}</h3>
              <p className="mt-3 max-w-lg text-[#cbbbe6]">{s.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
